"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SUGGESTED_ACTIONS = void 0;
exports["default"] = setSuggestedActions;
var EMPTY_ARRAY = [];
var SET_SUGGESTED_ACTIONS = 'WEB_CHAT/SET_SUGGESTED_ACTIONS';
exports.SET_SUGGESTED_ACTIONS = SET_SUGGESTED_ACTIONS;

function setSuggestedActions() {
  var suggestedActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return {
    type: SET_SUGGESTED_ACTIONS,
    payload: {
      suggestedActions: suggestedActions
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFTVBUWV9BUlJBWSIsIlNFVF9TVUdHRVNURURfQUNUSU9OUyIsInNldFN1Z2dlc3RlZEFjdGlvbnMiLCJzdWdnZXN0ZWRBY3Rpb25zIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZXRTdWdnZXN0ZWRBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IEVNUFRZX0FSUkFZID0gW107XG5cbmNvbnN0IFNFVF9TVUdHRVNURURfQUNUSU9OUyA9ICdXRUJfQ0hBVC9TRVRfU1VHR0VTVEVEX0FDVElPTlMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZXRTdWdnZXN0ZWRBY3Rpb25zKHN1Z2dlc3RlZEFjdGlvbnMgPSBFTVBUWV9BUlJBWSkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFVF9TVUdHRVNURURfQUNUSU9OUyxcbiAgICBwYXlsb2FkOiB7IHN1Z2dlc3RlZEFjdGlvbnMgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfU1VHR0VTVEVEX0FDVElPTlMgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFdBQVcsR0FBRyxFQUFwQjtBQUVBLElBQU1DLHFCQUFxQixHQUFHLGdDQUE5Qjs7O0FBRWUsU0FBU0MsbUJBQVQsR0FBNkQ7RUFBQSxJQUFoQ0MsZ0JBQWdDLHVFQUFiSCxXQUFhO0VBQzFFLE9BQU87SUFDTEksSUFBSSxFQUFFSCxxQkFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsZ0JBQWdCLEVBQWhCQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=